export const getInitialsFromFullName = (input: string): string => {
  const names: string[] = input?.split(" ");

  if (!names || names?.length === 0) {
    return "";
  }

  const firstNameInitial = names?.[0]?.[0]?.toUpperCase();
  const lastNameInitial = names?.[names.length - 1]?.[0]?.toUpperCase();

  return firstNameInitial + lastNameInitial;
};
